import { AdvancedCombobox } from '@evertrue/et-components';
import { useIdentity } from 'base/identity-resolver';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { fetchAllJourneysForAllJourneyGroups } from '../utils/api-requests/journey-index';

const JourneySelector = ({ value = [], onChange = () => {} }) => {
  const { user } = useIdentity();
  const [journeysList, setJourneysList] = useState([]);

  useEffect(() => {
    const getAndSetJourneys = async () => {
      const journeysListResponse = await fetchAllJourneysForAllJourneyGroups();
      const sortedJourneys = journeysListResponse
        ?.map((j) => ({ label: j?.name, value: j?.id }))
        ?.sort((a, b) => a.label.localeCompare(b.label));
      setJourneysList(sortedJourneys);
    };
    getAndSetJourneys();
  }, [user?.id]);

  return (
    <AdvancedCombobox
      options={journeysList}
      value={value}
      search_placeholder={'Search Cadence...'}
      placeholder="Select Cadence..."
      onChange={onChange}
      searchable
      multiple
      allowChangeAll
      allowUnselectAll
    />
  );
};

JourneySelector.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func,
};

export default JourneySelector;
